import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AUTH_SERVICE } from '../services/auth.service';
import { Psychologist } from '../models/psychologists';
import { PsychologistService } from '../services/psychologist.service';
import TYPES from '../constants/types';

export const premiumAccountGuard: CanActivateFn = async (route, state) => {

  const authService = inject(AUTH_SERVICE);
  const psychologistService: PsychologistService<Psychologist> = inject(PsychologistService<Psychologist>);
  const router = inject(Router);

  if(!authService.user()){
    await authService.getUser();
  }

  if(authService.user()?.profile === TYPES.DATABASE.PROFILES.PSYCHOLOGIST.key){
    let userId = authService.user()?.id;
  
    if(userId){
      if(!psychologistService.psychologist()){
        await psychologistService.getPsychologistByUserId(userId);
      }
      
      let psychologist = psychologistService.psychologist();
      if(psychologist){
        if(psychologist.subscription_plan && psychologist.subscription_plan !== TYPES.DATABASE.PLANS.STARTER.code){
          return true;
        }
      }
    }
  }else{
    return true;
  }
  
  router.navigate(['/premium-feature'],{replaceUrl: true});
  return false;
  
};
